/**
 * Rider Status API
 * 라이더 현황 페이지 관련 API 호출
 */
import { apiClient } from '@/shared/api/client';
import {
    RiderFilter,
    RiderApiItem,
    SupplierListApiResponse,
} from '../types/riderStatus.types';

const BASE_PATH = '/api/v1/rider';

/**
 * 라이더 현황 API 서비스
 */
export const riderStatusApi = {
    /**
     * 라이더 목록 조회
     * GET /api/v1/rider/status
     */
    getRiderList: async (filters: RiderFilter = {}): Promise<RiderApiItem[]> => {
        const response = await apiClient.get<RiderApiItem[]>(
            `${BASE_PATH}/status`,
            { params: filters }
        );
        return response.data;
    },

    /**
     * 라이더 검색 (필터 조건으로)
     * POST /api/v1/rider/status/search
     */
    searchRiders: async (filters: RiderFilter = {}): Promise<RiderApiItem[]> => {
        const response = await apiClient.post<RiderApiItem[]>(
            `${BASE_PATH}/status/search`,
            filters
        );

        return response.data;
    },

    /**
     * 협력사(공급업체) 목록 조회
     * GET /api/v1/suppliers
     */
    getSuppliers: async (): Promise<SupplierListApiResponse> => {
        const response = await apiClient.get<SupplierListApiResponse>(
            `${BASE_PATH}/suppliers`
        );
        return response.data;
    },

    /**
     * 라이더 현황 엑셀 다운로드 (VPay 가입여부 포함)
     *
     * Post /api/v1/rider/status/excel
     */
    downloadRiderStatusExcel: async (filters: RiderFilter = {}): Promise<Blob> => {
        const response = await apiClient.post<Blob>(`${BASE_PATH}/status/excel`, filters, {
            responseType: 'blob',
            timeout: 300000 // 5분
        });
        return response.data;
    }
};
